module.exports = __webpack_public_path__ + "img/TAC6000&TAM4000.8d0fc799.png";